// extracted by mini-css-extract-plugin
export default {"page_layout":"PageLayout_page_layout__3LJ-P","content":"PageLayout_content__Rxe9a"};